import React from "react";
import { Grid, Typography } from "@mui/material";
import { StyledTextField } from "../../utilities/styles/checkoutPage.style";

interface GuestCountSectionProps {
    expectedGuestCount: number;
    organizationSettings: any;
    classes: any;
    validator: any;
    onChange: (e: any, fieldName: string) => void;
}

const GuestCountSection: React.FC<GuestCountSectionProps> = ({
    expectedGuestCount,
    organizationSettings,
    classes,
    validator,
    onChange,
}) => {
    if (!organizationSettings?.enableGuestCount) {
        return null;
    }

    return (
        <>
            <Typography
                gutterBottom
                sx={{
                    mt: 4,
                    mb: 2,
                    fontSize: { sm: "20px" },
                    fontWeight: 600,
                }}
            >
                Guests
            </Typography>
            <Grid container spacing={2} direction="row">
                <Grid item xs={12} sm={6}>
                    <StyledTextField
                        name="expectedGuestCount"
                        type="number"
                        className={classes.marginBottom5}
                        id="expectedGuestCount"
                        value={expectedGuestCount}
                        onChange={(e) => {
                            if (
                                e.target.value === "" ||
                                (e.target.value.length <= 6 && /^\d*$/.test(e.target.value))
                            ) {
                                onChange(e, "expectedGuestCount");
                            }
                        }}
                        label="Expected Guest Count"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        variant="outlined"
                        inputProps={{
                            style: { textAlign: "left" },
                            maxLength: 6,
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                        }}
                    />
                    {validator.message(
                        "expected guest count",
                        expectedGuestCount,
                        "noSpecialChar"
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default GuestCountSection;
